import { dateIt } from "@/lib/format";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const upcomingEditions = (editions) => {
  const today = new Date().toISOString().slice(0, 10);
  return (editions || []).filter((e) => e.published !== false && (e.start_date || "") >= today);
};

export const editionLabel = (e) => [dateIt(e.start_date), e.start_time, e.location].filter(Boolean).join(" · ");

export function EditionSelect({ editions, value, onChange }) {
  return (
    <div className="space-y-1.5 text-left" data-testid="edition-select-box">
      <Label className="text-xs font-semibold text-slate-600">Edizione in programma *</Label>
      {editions.length === 0 ? (
        <div className="text-sm text-red-600" data-testid="edition-select-empty">Nessuna edizione in programma al momento.</div>
      ) : (
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger data-testid="edition-select"><SelectValue placeholder="Seleziona l'edizione" /></SelectTrigger>
          <SelectContent>
            {editions.map((e) => {
              const full = typeof e.seats_available === "number" && e.seats_available <= 0;
              return (
                <SelectItem key={e.id} value={e.id} disabled={full} data-testid={`edition-option-${e.id}`}>
                  {editionLabel(e)}{typeof e.seats_available === "number" ? ` · ${full ? "Completa" : `${e.seats_available} posti`}` : ""}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
